// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file checkout/mpp/v1/checkout_mpp_api.proto (package checkout.mpp.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Value } from "../../../google/protobuf/struct_pb";
import { AccessPrivilege, ExpiryInfo, MerchantInfo, UserType } from "../../../common/v1/common_pb";
import { Cart } from "../../../merchant/v1/cart_pb";
import { Shopper } from "../../../common/v1/shopper_pb";
import { Link, LinkStatus } from "../../../headless/v1/link_pb";
import { CreateMerchantSettingsPayload, CreateSegmentPayload, MerchantSettings, PageType, ReferenceData, Segment } from "../../../common/v1/merchant_settings_pb";
import { FieldMask } from "../../../google/protobuf/field_mask_pb";

/**
 * @generated from message checkout.mpp.v1.AuthorizeRequest
 */
export const AuthorizeRequest = proto3.makeMessageType(
  "checkout.mpp.v1.AuthorizeRequest",
  () => [
    { no: 1, name: "extensions", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Value} },
  ],
);

/**
 * @generated from message checkout.mpp.v1.AuthorizeResponse
 */
export const AuthorizeResponse = proto3.makeMessageType(
  "checkout.mpp.v1.AuthorizeResponse",
  () => [
    { no: 1, name: "session_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "access_privilege", kind: "enum", T: proto3.getEnumType(AccessPrivilege) },
    { no: 3, name: "merchants_info", kind: "message", T: MerchantInfo, repeated: true },
    { no: 4, name: "user_type", kind: "enum", T: proto3.getEnumType(UserType) },
    { no: 5, name: "profile_owner_eci", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.mpp.v1.CreateOrUpdatePaymentLinkRequest
 */
export const CreateOrUpdatePaymentLinkRequest = proto3.makeMessageType(
  "checkout.mpp.v1.CreateOrUpdatePaymentLinkRequest",
  () => [
    { no: 1, name: "link_external_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "reference", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cart", kind: "message", T: Cart },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "expiry_info", kind: "message", T: ExpiryInfo },
    { no: 9, name: "shopper", kind: "message", T: Shopper },
    { no: 10, name: "status", kind: "enum", T: proto3.getEnumType(LinkStatus) },
    { no: 11, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "three_ds_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "purchase_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "partial_authorization_support", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message checkout.mpp.v1.CreateOrUpdatePaymentLinkResponse
 */
export const CreateOrUpdatePaymentLinkResponse = proto3.makeMessageType(
  "checkout.mpp.v1.CreateOrUpdatePaymentLinkResponse",
  () => [
    { no: 1, name: "payment_link_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "link", kind: "message", T: Link },
  ],
);

/**
 * @generated from message checkout.mpp.v1.ListPaymentLinksRequest
 */
export const ListPaymentLinksRequest = proto3.makeMessageType(
  "checkout.mpp.v1.ListPaymentLinksRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "order_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.mpp.v1.ListPaymentLinksResponse
 */
export const ListPaymentLinksResponse = proto3.makeMessageType(
  "checkout.mpp.v1.ListPaymentLinksResponse",
  () => [
    { no: 1, name: "links", kind: "message", T: Link, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.mpp.v1.CreateAndPromoteMerchantSettingsRequest
 */
export const CreateAndPromoteMerchantSettingsRequest = proto3.makeMessageType(
  "checkout.mpp.v1.CreateAndPromoteMerchantSettingsRequest",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: CreateMerchantSettingsPayload },
  ],
);

/**
 * @generated from message checkout.mpp.v1.CreateSegmentRequest
 */
export const CreateSegmentRequest = proto3.makeMessageType(
  "checkout.mpp.v1.CreateSegmentRequest",
  () => [
    { no: 1, name: "segment", kind: "message", T: CreateSegmentPayload },
  ],
);

/**
 * @generated from message checkout.mpp.v1.CreateAndPromoteMerchantSettingsResponse
 */
export const CreateAndPromoteMerchantSettingsResponse = proto3.makeMessageType(
  "checkout.mpp.v1.CreateAndPromoteMerchantSettingsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * @generated from message checkout.mpp.v1.CreateSegmentResponse
 */
export const CreateSegmentResponse = proto3.makeMessageType(
  "checkout.mpp.v1.CreateSegmentResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * @generated from message checkout.mpp.v1.UpdateMerchantSettingsRequest
 */
export const UpdateMerchantSettingsRequest = proto3.makeMessageType(
  "checkout.mpp.v1.UpdateMerchantSettingsRequest",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: CreateMerchantSettingsPayload },
    { no: 2, name: "field_mask", kind: "message", T: FieldMask },
  ],
);

/**
 * @generated from message checkout.mpp.v1.UpdateMerchantSettingsResponse
 */
export const UpdateMerchantSettingsResponse = proto3.makeMessageType(
  "checkout.mpp.v1.UpdateMerchantSettingsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * @generated from message checkout.mpp.v1.ExchangeCodeForTokenRequest
 */
export const ExchangeCodeForTokenRequest = proto3.makeMessageType(
  "checkout.mpp.v1.ExchangeCodeForTokenRequest",
  () => [
    { no: 1, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "error_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "product_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.mpp.v1.ExchangeCodeForTokenResponse
 */
export const ExchangeCodeForTokenResponse = proto3.makeMessageType(
  "checkout.mpp.v1.ExchangeCodeForTokenResponse",
  () => [
    { no: 1, name: "mids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "settings_session_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "access_privilege", kind: "enum", T: proto3.getEnumType(AccessPrivilege) },
    { no: 4, name: "profile_owner_eci", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "merchant_info", kind: "message", T: MerchantInfo, repeated: true },
    { no: 6, name: "user_type", kind: "enum", T: proto3.getEnumType(UserType) },
  ],
);

/**
 * @generated from message checkout.mpp.v1.GetSettingsBundleRequest
 */
export const GetSettingsBundleRequest = proto3.makeMessageType(
  "checkout.mpp.v1.GetSettingsBundleRequest",
  () => [
    { no: 1, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_type", kind: "enum", T: proto3.getEnumType(PageType), opt: true },
  ],
);

/**
 * @generated from message checkout.mpp.v1.GetSettingsBundleResponse
 */
export const GetSettingsBundleResponse = proto3.makeMessageType(
  "checkout.mpp.v1.GetSettingsBundleResponse",
  () => [
    { no: 1, name: "reference_data", kind: "message", T: ReferenceData },
    { no: 2, name: "active_settings", kind: "message", T: MerchantSettings },
    { no: 3, name: "segment", kind: "message", T: Segment, repeated: true },
    { no: 4, name: "max_segments_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message checkout.mpp.v1.DeleteSegmentRequest
 */
export const DeleteSegmentRequest = proto3.makeMessageType(
  "checkout.mpp.v1.DeleteSegmentRequest",
  () => [
    { no: 1, name: "segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.mpp.v1.DeleteSegmentResponse
 */
export const DeleteSegmentResponse = proto3.makeMessageType(
  "checkout.mpp.v1.DeleteSegmentResponse",
  () => [
    { no: 1, name: "segment", kind: "message", T: Segment, repeated: true },
  ],
);

/**
 * @generated from message checkout.mpp.v1.GetPaymentLinkRequest
 */
export const GetPaymentLinkRequest = proto3.makeMessageType(
  "checkout.mpp.v1.GetPaymentLinkRequest",
  () => [
    { no: 1, name: "external_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.mpp.v1.GetPaymentLinkResponse
 */
export const GetPaymentLinkResponse = proto3.makeMessageType(
  "checkout.mpp.v1.GetPaymentLinkResponse",
  () => [
    { no: 1, name: "link", kind: "message", T: Link },
  ],
);

/**
 * @generated from message checkout.mpp.v1.ExportPaymentLinksRequest
 */
export const ExportPaymentLinksRequest = proto3.makeMessageType(
  "checkout.mpp.v1.ExportPaymentLinksRequest",
  () => [
    { no: 1, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message checkout.mpp.v1.ExportPaymentLinksResponse
 */
export const ExportPaymentLinksResponse = proto3.makeMessageType(
  "checkout.mpp.v1.ExportPaymentLinksResponse",
  () => [
    { no: 1, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message checkout.mpp.v1.SendPaymentLinkEmailRequest
 */
export const SendPaymentLinkEmailRequest = proto3.makeMessageType(
  "checkout.mpp.v1.SendPaymentLinkEmailRequest",
  () => [
    { no: 2, name: "link_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "send_to", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message checkout.mpp.v1.SendPaymentLinkEmailResponse
 */
export const SendPaymentLinkEmailResponse = proto3.makeMessageType(
  "checkout.mpp.v1.SendPaymentLinkEmailResponse",
  [],
);

/**
 * @generated from message checkout.mpp.v1.UploadLogoRequest
 */
export const UploadLogoRequest = proto3.makeMessageType(
  "checkout.mpp.v1.UploadLogoRequest",
  () => [
    { no: 1, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "logo", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * @generated from message checkout.mpp.v1.UploadLogoResponse
 */
export const UploadLogoResponse = proto3.makeMessageType(
  "checkout.mpp.v1.UploadLogoResponse",
  () => [
    { no: 1, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * RegisterMerchantToApplePayRequest defines the domains to be registered to Apple Pay.
 *
 * @generated from message checkout.mpp.v1.RegisterMerchantToApplePayRequest
 * @deprecated
 */
export const RegisterMerchantToApplePayRequest = proto3.makeMessageType(
  "checkout.mpp.v1.RegisterMerchantToApplePayRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * RegisterMerchantToApplePayResponse defines the settings ID of Apple Pay changes.
 *
 * @generated from message checkout.mpp.v1.RegisterMerchantToApplePayResponse
 * @deprecated
 */
export const RegisterMerchantToApplePayResponse = proto3.makeMessageType(
  "checkout.mpp.v1.RegisterMerchantToApplePayResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * UnregisterMerchantToApplePayRequest defines the domains to be unregistered to Apple Pay.
 *
 * @generated from message checkout.mpp.v1.UnregisterMerchantToApplePayRequest
 * @deprecated
 */
export const UnregisterMerchantToApplePayRequest = proto3.makeMessageType(
  "checkout.mpp.v1.UnregisterMerchantToApplePayRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * UnregisterMerchantToApplePayResponse defines the settings ID of Apple Pay changes.
 *
 * @generated from message checkout.mpp.v1.UnregisterMerchantToApplePayResponse
 * @deprecated
 */
export const UnregisterMerchantToApplePayResponse = proto3.makeMessageType(
  "checkout.mpp.v1.UnregisterMerchantToApplePayResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * AddApplePayDomainsRequest defines the domains to be added.
 *
 * @generated from message checkout.mpp.v1.AddApplePayDomainsRequest
 */
export const AddApplePayDomainsRequest = proto3.makeMessageType(
  "checkout.mpp.v1.AddApplePayDomainsRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * RegisterMerchantToApplePayResponse defines the settings of Apple Pay changes.
 *
 * @generated from message checkout.mpp.v1.AddApplePayDomainsResponse
 */
export const AddApplePayDomainsResponse = proto3.makeMessageType(
  "checkout.mpp.v1.AddApplePayDomainsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * VerifyApplePayDomainsRequest defines the domains to be registered to Apple Pay.
 *
 * @generated from message checkout.mpp.v1.VerifyApplePayDomainsRequest
 */
export const VerifyApplePayDomainsRequest = proto3.makeMessageType(
  "checkout.mpp.v1.VerifyApplePayDomainsRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * VerifyApplePayDomainsResponse defines the settings of Apple Pay changes.
 *
 * @generated from message checkout.mpp.v1.VerifyApplePayDomainsResponse
 */
export const VerifyApplePayDomainsResponse = proto3.makeMessageType(
  "checkout.mpp.v1.VerifyApplePayDomainsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

/**
 * DeleteApplePayDomainsRequest defines the domains to be deleted and un-registered to Apple Pay.
 *
 * @generated from message checkout.mpp.v1.DeleteApplePayDomainsRequest
 */
export const DeleteApplePayDomainsRequest = proto3.makeMessageType(
  "checkout.mpp.v1.DeleteApplePayDomainsRequest",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "domain_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * DeleteApplePayDomainsRequest defines the settings of Apple Pay changes.
 *
 * @generated from message checkout.mpp.v1.DeleteApplePayDomainsResponse
 */
export const DeleteApplePayDomainsResponse = proto3.makeMessageType(
  "checkout.mpp.v1.DeleteApplePayDomainsResponse",
  () => [
    { no: 1, name: "merchant_settings", kind: "message", T: MerchantSettings },
  ],
);

